// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".drawer div.v-navigation-drawer__border{border:0;display:none}.screening-header-text{word-wrap:normal;text-align:center}.screening-header-h1{font-size:44px;line-height:1em}.screening-header-h1,.screening-header-h2{color:var(--v-primary-base);font-weight:700;letter-spacing:0}.screening-header-h2{font-size:21px}.screening-subtitle{color:#a0a0a0;font-size:21px;font-style:italic;letter-spacing:0}.v-select.v-input--dense .v-chip{height:20px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
